<template>
	<div id="Installments" class="box">
		<UpdatePaymentInformation
			:order="this.selectedOrder"
			:order-payment="this.selectedOrderPayment"
			v-if="shouldShowPayNowModal"
			@update-orders="onUpdateOrders"
			@close="togglePayNowModal"
		/>
		<div id="OrdersInstallments">
			<div>
				<h3>Your Installments &amp; Payment Requests</h3>
				<div class="center" v-if="installment.loading === true">
					<LoadingSpinner />
				</div>
				<div v-if="installment.loading !== true && installment.loaded !== true" style="text-align: center;">
					<button type="button" @click.prevent="Load()">
						<i class="fas fa-sync-alt"></i> Load Installments &amp; Payment Requests
					</button>
				</div>
				<div v-if="installment.loading !== true && installment.loaded === true && installments.length < 1">
					<div style="text-align: center;font-size:.7em;margin-bottom:10px;">
						<h4 style="color:red !important;">No Installments or Payment Requests Found</h4>
					</div>
					<div style="text-align: center;">
						<button type="button" @click.prevent="Load()">
							<i class="fas fa-sync-alt"></i> Reload Installments &amp; Payment Requests
						</button>
					</div>
				</div>
				<div v-if="installment.loading !== true && installment.loaded === true && installments.length > 0">
					<table id="user-installments" class="creds-table">
						<thead>
							<tr>
								<th>OrderId</th>
								<th>Installment No.</th>
								<th>Due Date</th>
								<th>Last 4 Digits on Card</th>
								<th class="status-column">Status</th>
								<th>Total</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(payment, index) in installments"
								v-bind:key="payment.id"
								:style="{
									'background-color': getRowShadingColor(payment, index),
									'white-space': 'pre',
									color: getRowFontColor(payment, index)
								}"
								@mouseover="currentMouseOverRowIndex = index"
								@mouseleave="currentMouseOverRowIndex = -1"
								v-tooltip="getOrderPaymentTooltip(payment)"
							>
								<td label="OrderId">
									<strong>{{ FormatOrderNumber(payment.order_id, payment.updated_at) }}</strong>
								</td>
								<td style="/* this doesn't work, used <center>: */text-align:center;" label="Installment">
									<center>{{ payment.installment_number }}/{{ numInstallmentsPerOrder[payment.order_id] }}</center>
								</td>
								<td label="Due Date">{{ payment.scheduled_to }}</td>
								<td label="Last 4 Digits">{{ payment.last_digits }}</td>
								<template v-if="payment.status">
									<td label="Status" style="" class="status-column">
										<strong>
											<span :style="getStatusStyle(payment, index)">{{ getStatusText(payment) }}</span>
										</strong>
									</td>
								</template>
								<template v-else>
									<td></td>
								</template>
								<td label="Total" :data-last="disallowedPayNowStatus.includes(payment.payment_status_id)">${{ payment.value }} {{ payment.currency }}</td>
								<td label="Actions" :data-hide="disallowedPayNowStatus.includes(payment.payment_status_id)">
									<button
										type="button"
										v-if="!disallowedPayNowStatus.includes(payment.payment_status_id)"
										@click.prevent="
											togglePayNowModal(
												user_orders.find(x => x.id === payment.order_id),
												payment
											)
										"
										@mouseover="currentMouseOverBtnId = payment.id"
										@mouseleave="currentMouseOverBtnId = -1"
										style="margin:0px;"
										:style="getPayNowBtnStyle(payment)"
									>Pay Now</button>
								</td>
							</tr>
						</tbody>
					</table>
					<div style="text-align: center;">
						<button type="button" @click.prevent="Load()">
							<i class="fas fa-sync-alt"></i> Reload Installments &amp; Payment Requests
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios"
	import LoadingSpinner from "./LoadingSpinner.vue"
	import api from "@/service/api"
	import UpdatePaymentInformation from "./UpdatePaymentInformation.vue"

	export default {
		name: "OrderInstallments",
		components: {
			LoadingSpinner,
			UpdatePaymentInformation
		},
		data() {
			return {
				orders: window.portal.orders,
				user_orders: window.portal.orders.orders,
				installment: {},
				installments: [],
				selectedOrder: {},
				selectedOrderPayment: null,
				shouldShowPayNowModal: false,
				disallowedPayNowStatus: [
					2, // STATUS_CREATED
					3, // STATUS_PLACED
					6, // STATUS_CANCELED
					7, // STATUS_REFUNDED
					9, // STATUS_REFUNDED_COMPLETED
					12, // STATUS_CHARGEBACK
					13, // STATUS_PARTIAL_REFUND
					14 // STATUS_INVOICED_VIA_SHOPIFY
				],
				showPaysafeErrorStatuses: [4, 11],
				// These change the style of the row based on the payment status
				rowSettings: {
					1: {
						status_text: "Awaiting Payment"
					},
					2: {
						status_text: "Awaiting Settlement"
						//color_status: '#10B882',
					},
					3: {
						status_text: "Paid",
						color_status: "#10B882"
						//color_row_hover: '#999999',
					},
					4: {
						color_status: "#EF4543",
						color_pay_now_btn: "#EF4543",
						color_row_shading: "#FEF3F3",
						color_row_hover: "#FFC9C9"
					},
					11: {
						status_text: "Error",
						color_pay_now_btn: "#F84543",
						color_row_shading: "#FEF3F3",
						//color_row_hover: '#FF5E67',
						color_row_hover: "#F84543",
						color_row_hover_text: "#FFF",
						color_row_background: "#FFC9C9"
					}
				},
				// Allows for customizing hover css via Vue
				currentMouseOverRowIndex: -1,
				currentMouseOverBtnId: -1,
				inView: false
			}
		},
		computed: {
			numInstallmentsPerOrder: function() {
				const installments = this.installments
				return installments.reduce((acc, item) => {
					const { order_id, installment_number } = item
					acc = { ...acc }

					if (!acc[order_id]) {
						acc[order_id] = installment_number
					} else {
						acc[order_id] = Math.max(acc[order_id], installment_number)
					}

					return acc
				}, {})
			}
		},
		mounted: function() {
			this.installment.loading = false
			this.installment.loaded = false

			window.addEventListener("scroll", this.handleScroll)
		},
		methods: {
			formatDateToLocal(date) {
				const monthNames = [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December"
				]
				try {
					var d = new Date(date + " 12:00:00 PST")
					return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`
				} catch (e) {
					return date
				}
			},
			getOrderPaymentTooltip(payment) {
				// If there's an error, let the guest know
				if (payment.payment_status_id === 11) {
					return {
						content:
							"<p style='text-align:center'>We attempted to charge your card:<br/><br/>" +
							payment.last_payment_error_message +
							"<br/><br/>We will try again </html>" +
							this.formatDateToLocal(payment.scheduled_to),
						html: true
					}
				}
				return ""
			},
			FormatOrderNumber(order_num, date) {
				const d = new Date(date)
				window.debug(
					`ORDER FOUND: ${String(order_num).padLeft(8, "0")}${d.getFullYear()}${String(d.getMonth()).padLeft(
						2,
						"0"
					)}${String(d.getDate()).padLeft(2, "0")}${String(d.getHours()).padLeft(2, "0")}`
				) // return `${String(order_num).padLeft(8,'0')}${d.getFullYear()}${String(d.getMonth()).padLeft(2,'0')}${String(d.getDate()).padLeft(2,'0')}${String(d.getHours()).padLeft(2,'0')}`;
				/*long order number*/
				return `${order_num}`
			},
			Clear() {
				window.portal.clearOrders()
			},
			Load() {
				this.installment.loading = true
				this.installment.loaded = false
				this.$forceUpdate()
				this.installments = []
				axios.defaults.headers.common["X-Auth-Token"] = window.portal.session.token
				axios
					.post(`${window.portal.api_server}/userportal/orders`, {
						confirm: window.portal.user.id.decode().encode()
					})
					.then(async res => {
						if (res.data.status.success) {
							this.user_orders = res.data.data
							window.debug(res.data.data)
							window.debug("USER ORDERS LOADED")
							try {
								const { data } = await api.fetchOrderInstallments(window.portal.user.id.decode())
								this.installments = data
							} catch (e) {
								window.debug(e)
							}

							this.installment.loading = false
							this.installment.loaded = true
							this.$forceUpdate()
						}
					})
					.catch(err => {
						window.debug("USER ORDERS FAILURE")
						window.debug(err)
						this.installment.loading = false
						this.installment.loaded = true
						this.$forceUpdate()
					})
			},
			Email(event, order_id) {
				event.preventDefault()
				document.getElementById(`order_${order_id}`).classList.add("hide")
				document.getElementById(`send_order_${order_id}`).classList.remove("hide")
				axios.defaults.headers.common["X-Auth-Token"] = window.portal.session.token
				axios
					.post(`${window.portal.api_server}/userportal/orderreemail`, {
						confirm: window.portal.user.id.decode().encode(),
						order: String(order_id).encode()
					})
					.then(res => {
						if (res.data.status.success) {
							window.debug(res.data.data)
							window.debug("ORDER EMAILED")
						}
					})
					.catch(err => {
						window.debug("ORDER EMAIL FAILURE")
						window.debug(err)
						window.portal.logout()
					})
			},
			togglePayNowModal(order = null, orderPayment = null) {
				if (order) {
					this.selectedOrder = order
				}
				if (orderPayment) {
					this.selectedOrderPayment = orderPayment
				}
				this.shouldShowPayNowModal = !this.shouldShowPayNowModal
			},
			onUpdateOrders() {
				// Update payments after making payment
				this.Load()
			},
			// Getters for row GUI
			getStatusText(payment) {
				if (this.rowSettings[payment.payment_status_id] !== undefined) {
					if (this.rowSettings[payment.payment_status_id]["status_text"] !== undefined) {
						return this.rowSettings[payment.payment_status_id]["status_text"]
					}
				}
				return payment.status.status
			},
			getRowFontColor(payment, idx) {
				if (
					this.currentMouseOverRowIndex === idx &&
					this.rowSettings[payment.payment_status_id].color_row_hover_text !== undefined
				) {
					if (this.rowSettings[payment.payment_status_id] !== undefined) {
						if (this.rowSettings[payment.payment_status_id].color_row_hover_text !== undefined) {
							return this.rowSettings[payment.payment_status_id].color_row_hover_text
						}
					}
				}
				return ""
			},
			getRowShadingColor(payment, idx) {
				if (this.rowSettings[payment.payment_status_id] !== undefined) {
					// If hovering on row, use hover color
					if (
						this.currentMouseOverRowIndex === idx &&
						this.rowSettings[payment.payment_status_id].color_row_hover !== undefined
					) {
						return this.rowSettings[payment.payment_status_id].color_row_hover
					}
					// if background color is set, use it
					if (this.rowSettings[payment.payment_status_id].color_row_background !== undefined) {
						return this.rowSettings[payment.payment_status_id].color_row_background
					}
					if (this.rowSettings[payment.payment_status_id].color_row_shading !== undefined) {
						return this.rowSettings[payment.payment_status_id].color_row_shading
					}
				}
				return ""
			},
			getStatusStyle(payment, idx) {
				if (this.rowSettings[payment.payment_status_id] !== undefined) {
					var styles = {}
					if (this.rowSettings[payment.payment_status_id].color_status !== undefined) {
						// Build out status style
						styles["border"] = `1px solid ${this.rowSettings[payment.payment_status_id].color_status}`
						styles["background-color"] = `${this.rowSettings[payment.payment_status_id].color_status}`
						styles["padding"] = "3px 7px 3px 7px"
						styles["color"] = "white"
					}
					return styles
				}
				return {}
			},
			getPayNowBtnStyle(payment) {
				const defaultColor = "var(--button-background)"
				// Consistent button hover color
				if (this.currentMouseOverBtnId === payment.id) {
					return { background: `var(--link-color-hover)` }
				}
				// Find proper color
				if (this.rowSettings[payment.payment_status_id] !== undefined) {
					if (this.rowSettings[payment.payment_status_id].color_pay_now_btn !== undefined) {
						return { background: `${this.rowSettings[payment.payment_status_id].color_pay_now_btn}` }
					}
				}
				return { background: `${defaultColor}` }
			},
			handleScroll() {
				const element = this.$el
				const elementRect = element.getBoundingClientRect()
				const inView = elementRect.top < window.innerHeight && elementRect.bottom >= 0
				if (inView && !this.inView) {
					this.inView = true
					this.Load()
				}
			}
		}
	}
</script>

<style>
	#Installments h3 {
		text-transform: uppercase;
		text-align: center;
		font-size: 24px;
		padding: 15px;
		margin: 0;
	}

	@media screen and (max-width: 800px) {
		#user-installments {
			text-align: left;
		}

		#user-installments thead {
			display: none;
		}

		#user-installments td {
			display: flex;
			height: 2.25em;
			margin: 0;
			padding: 0;
		}

		#user-installments tr td:first-child {
			margin-top: 1.5em;
		}

		#user-installments tr td:last-child,
		#user-installments [data-last="true"] {
			margin-bottom: 0.8em;
		}

		#user-installments tr td:last-child {
			margin-bottom: 1.5em;
		}

		#user-installments tr {
			border-bottom: 2px solid #a3a3a3;
		}

		#user-installments tr:last-child {
			border-bottom: none;
		}

		#user-installments td::before {
			content: attr(label);
			font-weight: bold;
			width: 10em;
			min-width: 10em;
			text-align: left;
		}

		#user-installments td[label="OrderId"]::before {
			text-decoration: underline;
		}

		#user-installments [data-hide="true"] {
			display: none;
		}
	}

	@media screen and (min-width: 800px) {
		#user-installments .status-column {
			text-align: left;
			padding-left: 35px;
		}
	}
</style>
